import { OptionType } from '@evinced-private/ui-common';

import { removeSelectAllOption } from 'src/common/helpers/GQLRequestsHelper/removeSelectAllOption';
import { IssuesTextSearchFields } from 'src/common/types/graphql.generated';

import { preprocessSearchValue } from '../../../helpers/MobileSearchHelper';
import {
	IGetMobileScansListParams,
	IMobileScansListFallbackVariables
} from '../MobileScansList.types';

const issuesSearchFields = [
	IssuesTextSearchFields.TypeName,
	IssuesTextSearchFields.SeverityName,
	IssuesTextSearchFields.ScanName,
	IssuesTextSearchFields.ElementsAccessibilityLabel,
	IssuesTextSearchFields.ElementsAccessibilityIdentifier,
	IssuesTextSearchFields.ElementsElementType,
	IssuesTextSearchFields.ElementsContentDescription,
	IssuesTextSearchFields.ElementsViewId,
	IssuesTextSearchFields.ElementsClassName,
	IssuesTextSearchFields.ElementsId,
	IssuesTextSearchFields.ElementsIndex,
	IssuesTextSearchFields.ElementsComponentId
];

const getFilterValues = (options: OptionType[] = []): string[] =>
	removeSelectAllOption(options).map(({ value }) => String(value));

export const buildMobileScansListFallbackVariables = ({
	runId,
	filterOptions
}: IGetMobileScansListParams): IMobileScansListFallbackVariables => {
	const variables: IMobileScansListFallbackVariables = {
		runId: { value: [runId] }
	};
	const searchValues = preprocessSearchValue(filterOptions?.searchValue ?? '');
	const severityValues = getFilterValues(filterOptions?.severities);
	const typeValues = getFilterValues(filterOptions?.types);
	const scanNameValues = getFilterValues(filterOptions?.scans);

	if (searchValues.length) {
		variables.textSearch = {
			insensitive: true,
			searchFields: issuesSearchFields,
			searchValues
		};
	}

	if (severityValues.length) {
		variables.severityIdFilter = { value: severityValues };
	}

	if (typeValues.length) {
		variables.typeIdFilter = { value: typeValues };
	}

	if (scanNameValues.length) {
		variables.scanNameFilter = { value: scanNameValues };
	}

	return variables;
};
